import React from 'react'
import PropTypes from 'prop-types'

const TopicSearchItem = ({ topic }) => (
  <div className="quest-topic autocomplete-result">
    <div className="cloud-name">{topic.topic_cloud.name}</div>
    <span className="carat"></span>
    <div className="parent-name">{topic.parent.name}</div>
    <div className="name">{topic.name}</div>
  </div>
)

TopicSearchItem.propTypes = {
  topic: PropTypes.object.isRequired
}

export default TopicSearchItem



// WEBPACK FOOTER //
// ./src/components/quest/topics/SearchItem.js